/**
 * Site-wide look & feel registry. Add new entries here and matching CSS under
 * html.pb-site-theme-{id} in siteTheme.css.
 */
export const SITE_THEME_STORAGE_KEY = "partyBossSiteTheme";
/** @deprecated migrated to SITE_THEME_STORAGE_KEY */
export const LEGACY_ANALYTICS_THEME_KEY = "bookingAnalyticsUiTheme";

export const SITE_THEMES = [
  {
    id: "classic",
    label: "Classic",
    shortLabel: "Classic",
    description: "Original Party Boss look — pink/violet on deep black (partyBossTheme.css).",
  },
  {
    id: "premium",
    label: "Dark Mode Lounge",
    shortLabel: "Lounge",
    description:
      "Premium glassmorphism — midnight canvas (#0B0A12), purple gradient accents, champagne gold highlights.",
  },
];

/** New installs and cleared storage use Dark Mode Lounge; Classic remains in the picker. */
export const DEFAULT_SITE_THEME_ID = "premium";

const THEME_IDS = new Set(SITE_THEMES.map((t) => t.id));

export function isValidSiteThemeId(id) {
  return THEME_IDS.has(String(id || "").trim());
}

export function siteThemeHtmlClass(themeId) {
  const id = isValidSiteThemeId(themeId) ? themeId : DEFAULT_SITE_THEME_ID;
  return `pb-site-theme-${id}`;
}

export function readStoredSiteThemeId() {
  try {
    let stored = localStorage.getItem(SITE_THEME_STORAGE_KEY);
    if (!stored) {
      stored = sessionStorage.getItem(LEGACY_ANALYTICS_THEME_KEY);
      if (stored && isValidSiteThemeId(stored)) {
        localStorage.setItem(SITE_THEME_STORAGE_KEY, stored);
        sessionStorage.removeItem(LEGACY_ANALYTICS_THEME_KEY);
      }
    }
    return isValidSiteThemeId(stored) ? stored : DEFAULT_SITE_THEME_ID;
  } catch {
    return DEFAULT_SITE_THEME_ID;
  }
}

export function persistSiteThemeId(themeId) {
  if (!isValidSiteThemeId(themeId)) return;
  try {
    localStorage.setItem(SITE_THEME_STORAGE_KEY, themeId);
  } catch {
    /* ignore */
  }
}

export function getSiteThemeById(id) {
  return SITE_THEMES.find((t) => t.id === id) || SITE_THEMES[0];
}
